const en = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title':
    'Discovery Source Name',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'User Id',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'Service Now Url',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Password',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'Invalid Url',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Discovery Frequency',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Prompt users to answer knowledge-based authentication (KBA) questions.',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'Discover your apps and workloads through one of these popular discovery sources. You will unlock benefits like prefilled details, prioritized recommendations, and a full view of onboarded status.',
  'INTEGRATIONS.DISCOVERY.BACK': 'Back',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Setup Discovery',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'Coming Soon...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'Learn More',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    "Enter your application credentials to establish a connection. Once the connection is successful, you'll be able to import data.",
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'Something went wrong while loading the page.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'Try refreshing, or check back later. If the issue persists, contact your administrator.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Reload',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Connection Settings',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'CI Classes***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Attribute Mapping',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Connection Details',
  'INTEGRATIONS.BUTTON.SAVE': 'Save',
  'INTEGRATIONS.BUTTON.UPDATE': 'Update',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Select',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'Create New Connection',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Use This Connection',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow Saved!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'Your connection to the discovery source ServiceNow has been successfully tested and saved. Import data to finalize setting up discovery. You may skip ...',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Import Assets',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Skip for Now',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'Once the import starts, it cannot be canceled',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Guide Me',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'Select Existing Connection',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Connection Name',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'We discovered {total, plural, one {an} other {#}} existing connection configuration:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'Start Import',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Importing data from Excel file. Please wait...',
  'INTEGRATIONS.TRY.AGAIN': 'Try Again',
  'INTEGRATIONS.CLOSE': 'Close',
  'INTEGRATIONS.ERROR.CONNECTION': 'Connection error. Please try again.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'You can exit the page while waiting. We will notify you once the process is complete.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Import Discovery Source',
  'INTEGRATIONS.FILEUPLOAD.HEADING': 'Import your discovery source from a file',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'Download Sample File',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Discovery Source Name',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Enter file name',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Please enter a valid name. Only letters, numbers, and select symbols are allowed.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'Uploading...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Continue',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Here are the first 10 records from the XLSX file uploaded.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'Mandatory Header Missing',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Column Errors Detected',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'Please fix the issues before proceeding to data import.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'Exclude from import',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'Application Onboarding Confirmation',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'We’ve identified the application type. Please confirm if this is the right application type you’re onboarding.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    "The application type you're onboarding is {applicationName}",
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'No, select from an application list',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    "Yes, I'm onboarding",
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Integrations',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'Add Integration',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'No results found for',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'No',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': 'integrations found.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN':
    'No hidden integrations available.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Applications Discovered',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Owner:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Last discovered on',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'Connection Failed',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'Users have access',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Discovery Source',
  'INTEGRATIONS.BUTTON.ENABLE': 'Enable',
  'INTEGRATIONS.BUTTON.DISABLE': 'Disable',
  'INTEGRATIONS.ENABLING': 'Enabling',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Discovery',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Re-upload',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Onboard',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Hide',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Unhide',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': 'Discovery configuration tabs',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'Discard unsaved changes?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'You have unsaved changes. Changes will be lost if you continue.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Discard Changes',
  'INTEGRATIONS.BUTTON.CANCEL': 'Cancel',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Save Error',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL': 'Go back to previous page',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'Application icon',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Run Manually',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE': 'Disabling Failed',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': 'Enabling Failed',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'Disabled successfully.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'Enabled successfully.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'Another import is currently in progress.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'Assets are currently being imported by another process. Please try again later.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED': 'Importing Failed',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS': 'Importing Assets from ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'You can exit the page while waiting. We’ll notify you once the process is complete.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Add new attribute mapping row',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Add Attribute',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Empty)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Delete this mapping',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'ServiceNow Field',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Saviynt Field',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'Search ServiceNow attribute',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': 'Search Saviynt attribute',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Custom)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Save failed',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Scheduling Configuration',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'at {timeLabel} UTC.',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Repeat On',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Repeat On Days',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Repeat Every',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Enter interval',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Repeat interval in number of days, weeks, or months',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'Day',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Week(s)',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Month',
  'INTEGRATIONS.DAYS.SUN': 'Sun',
  'INTEGRATIONS.DAYS.MON': 'Mon',
  'INTEGRATIONS.DAYS.TUE': 'Tue',
  'INTEGRATIONS.DAYS.WED': 'Wed',
  'INTEGRATIONS.DAYS.THU': 'Thu',
  'INTEGRATIONS.DAYS.FRI': 'Fri',
  'INTEGRATIONS.DAYS.SAT': 'Sat',
  'INTEGRATIONS.BUTTON.DISABLING': 'Disabling',
  'INTEGRATIONS.BUTTON.SAVED': 'Saved',
  'INTEGRATIONS.BUTTON.SAVING': 'Saving',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE': 'Are you sure you want to disable ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'By disabling the discovery source, asset import will be stopped and you won’t be able to configure the source.',
  'INTEGRATIONS.DISCOVERY.HERE': 'here',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'Your discovery source has been successfully created, but the connection to ServiceNow has failed. To start importing assets, please update the connection details on the discovery source configuration page ',
  'INTEGRATIONS.COPILOT.CREATEACCOUNT':
    'You can provide additional instructions to help me perform this action in the {applicationName} more accurately.\nFor example, you might say: ‘Navigate to Administration → User Management to create a user’ or ‘Navigate to Administration → Reports to download accounts’.\nDo you want to provide additional information?',
  'INTEGRATIONS.COPILOT.PROVIDEINFO':
    'Great! Please provide additional information.',
  'INTEGRATIONS.COPILOT.BASIC.UPDATE.SUCCESS':
    'You have updated the Application Details. I will add to the Configuration.',
  'INTEGRATIONS.COPILOT.CREATE_ACCOUNT.UPDATE.SUCCESS':
    'You have updated the Create Account configuration. I will add to the Configuration.',
  'INTEGRATIONS.COPILOT.UPDATE_ACCOUNT.UPDATE.SUCCESS':
    'You have updated the Update Account configuration. I will add to the Configuration.',
  'INTEGRATIONS.COPILOT.ENABLE_ACCOUNT.UPDATE.SUCCESS':
    'You have updated the Enable Account configuration. I will add to the Configuration.',
  'INTEGRATIONS.COPILOT.DISABLE_ACCOUNT.UPDATE.SUCCESS':
    'You have updated the Disable Account configuration. I will add to the Configuration.',
  'INTEGRATIONS.COPILOT.REMOVE_ACCOUNT.UPDATE.SUCCESS':
    'You have updated the Remove Account configuration. I will add to the Configuration.',
  'INTEGRATIONS.COPILOT.ADD_ACCESS.UPDATE.SUCCESS':
    'You have updated the Add Access Entitlements. I will add to the Configuration.',
  'INTEGRATIONS.COPILOT.REMOVE_ACCESS.UPDATE.SUCCESS':
    'You have updated the Remove Access Entitlements. I will add to the Configuration.',
  'INTEGRATIONS.COPILOT.ANALYZING_FILE':
    'Thanks for sharing. I’m analyzing your file, and this will take a few minutes.',
  'INTEGRATIONS.COPILOT.FILE_EXTRACTION':
    'Here I extracted instruction from your file.\nClick on "User Management" section\nClick on "User" option\nClick on filter/search fields\nChange to enter search criteria\nClick and doubleClick to select user\nClick on "Security profiles" tab\nClick on "Add" button\nClick and change for profile search\nClick on profile selection\nClick on "OK" buttons for confirmation.\n\nDo the above instructions align with your expectations?',
  'INTEGRATIONS.COPILOT.MOVING_NEXT': 'Thanks for sharing the instructions...',
  'INTEGRATIONS.COPILOT.ADDITION_INFORMATION':
    'Great! please provide additional information',
  'INTEGRATIONS.COPILOT.MOVING_TO_NEXT_STEP':
    'Thanks for sharing the instructions...',
  'INTEGRATIONS.COPILOT.MOVING_TO_UPDATE':
    'Great! Moving on to next step to update an account',
  'INTEGRATIONS.COPILOT.ADDITIONAL_INFORMATION':
    'Hey, I noticed you provided additional information while creating the account. Would you like to share similar details for updating the account as well?',
  'INTEGRATIONS.COPILOT.CONFIRM_ONBOARD':
    'Great, thanks for confirming! Should I go ahead and onboard your application now?',
  'INTEGRATIONS.COPILOT.LETS_GO': 'Let’s goooo! Onboarding your application',
  'INTEGRATIONS.COPILOT.SUCCESS':
    '✅ Congratulations! The Zendesk application has been successfully onboarded.',
  'INTEGRATIONS.COPILOT.RECOMMENDATION':
    'Is there anything else you’d like to do? I’ve some recommendation for you.',
  'INTEGRATIONS.COPILOT.REDIRECT':
    'Great! I’m redirecting you to the application page...',
  'INTEGRATIONS.COPILOT.ADD_MORE':
    'Sure! Can you share more information or specific details to improve the onboarding?\nI’ve some recommendation for you.',
  'INTEGRATIONS.COPILOT.ACCESS_ACCOUNT':
    'Great! Moving on to next step to add an access to account',
  'INTEGRATIONS.COPILOT.ADD_ACCESS':
    'Specify the {value0} user fields to populate (as in the Add access UI) and map them to corresponding Saviynt attributes',
  'INTEGRATIONS.COPILOT.ADD_ACCESS_DETAILS':
    'Hey, I noticed you provided additional information while creating the account. Would you like to share similar details for add access as well?',
  'INTEGRATIONS.COPILOT.DISABLE_STEP':
    'Great! Moving on to next step to disable an access to account',
  'INTEGRATIONS.COPILOT.DISABLE_STEP_INFORMATION':
    'Hey, I noticed you provided additional information while creating the account. Would you like to share similar details for disable access as well?',
  'INTEGRATIONS.COPILOT.REMOVE_ACCOUNT_INFORMATION':
    'Hey, I noticed you provided additional information while creating the account. Would you like to share similar details for remove the account as well?',
  'INTEGRATIONS.COPILOT.ENABLE_ACCOUNT_INFO':
    'Hey, I noticed you provided additional information while creating the account. Would you like to share similar details for enabling the account as well?',
  'INTEGRATIONS.COPILOT.DISABLE_ACCOUNT_INFO':
    'Hey, I noticed you provided additional information while creating the account. Would you like to share similar details for disabling the account as well?',
  'INTEGRATIONS.COPILOT.GETTING_STARTED': 'Lets Get Started!',
  'INTEGRATIONS.COPILOT.CREATE_APPLICATION': 'Creating application details',
  'INTEGRATIONS.COPILOT.CONNECTION_STEP':
    'Moving on to next step to setup a connection',
  'INTEGRATIONS.COPILOT.CONNECTION_STEP_ASSIT':
    'I’ll assist you with setting up connection details',
  'INTEGRATIONS.COPILOT.CONNECTION_STEP_ASSIT_INFO':
    'Hey, I recommend giving me a bit more instruction. I’ll start by trying to connect automatically, but if I can’t complete the process, I’ll rely on your guidance. The clearer your details—like required fields, values, or rules—the faster and more accurately I can get it done for you.\n\nFor example, you might say: ‘Enter username and password → click Login’.\n\nNow, you can provide instructions via: \n1. Prompt -  Type your instructions here. Clear, specific input helps me perform the operation.\n2. Upload - Share a Chrome DevTools recording of the task, and I’ll handle it.Do you want to provide additional information?',
  'INTEGRATIONS.COPILOT.CONFIRM_USE_CASE':
    'Ok. I’am moving on to next step to confirm the use cases',
  'INTEGRATIONS.COPILOT.CONFIRM_USE_CASE_STEP':
    'Confirm the use case to proceed with',
  'INTEGRATIONS.COPILOT.CREATE_ACCOUNT_NEXT_STEP':
    'Moving on to next step to create a account.',
  'COPILOT.CREATING_APPLICATION_DETAILS': 'Creating application details...',

  'AOB.common_config.securitysystems.systemname.title': 'Application Name',
  INTEGRATION_COPILOT_TOOLTIP_TEXT:
    'Provide the name of the application you are onboarding. This will be used to identify and manage the application within Saviynt.',
  INTEGRATION_COPILOT_CONNECTION_URL_TOOLTIP:
    'Enter the login page URL of the application',
  INTEGRATION_APPLICATION_NAME_PLACEHOLDER: 'Enter application name',
  INTEGRATION_APPLICATION_DESCRIPTION_PLACEHOLDER:
    'Enter description of your application',
  INTEGRATION_APPLICATION_URL: 'Enter URL',
  INTEGRATION_APPLICATION_USERNAME_PLACEHOLDER: 'Enter a user name',
  INTEGRATION_APPLICATION_PASSWORD_PLACEHOLDER: 'Enter a password',
  INTEGRATION_ASSIST_ON_CREATE_ACCOUNT:
    'Ok. I’ll assist you with setting up creating a account.\n Specify the external app fields to populate (as in the Create User UI) and map them to corresponding Saviynt attribute',
  INTEGRATION_COPILOT_APPLICATION_NAME_VALIDATION_API_ERROR:
    'I couldn’t complete your request to create an application details. This might be due to a temporary issue with the data service',
  'INTERGRATION.COPILOT.MOVING_TO_ATTRIBUTE_MAPPING':
    'Moving to next step for attribute mapping',
  'INTERGRATION.COPILOT.ATTRIBUTE_MAPPING_APPLICATION_FIELDS':
    'Specify the user field used to locate the user in the {value0}, then map it to the corresponding Saviynt attribute (e.g., Username). Then, provide the entitlement field that defines the access to be added',
  'INTEGRATIONS.COPILOT.ATTRIBUTE_MAPPING_START':
    'Specify the user field used to locate the user in the {value0}, then map it to the corresponding Saviynt attribute (e.g., Username). Then, provide the entitlement field that defines the access to be added',
  'INTEGRATIONS.COPILOT.ATTRIBUTE_MAPPING_NEXT':
    'Ok. Moving to next step for attribute mapping for {value0}',
  'INTEGRATIONS.COPILOT.ATTRIBUTE_MAPPING_ADDITIONAL_INFORMATION':
    "Hey, I recommend giving me a few more instructions to add role to user in {value0} application. I'll start by trying to add automatically, but if I can't complete the process, I'll rely on your guidance. The clearer your details — like navigation flow, required fields, values, or rules — the faster and more accurately I can get it done for you.\n\nFor example, you might say: 'Navigate to Administration → User Management -> Select the user -> Click Add Role -> Select the role -> Save'.\n\nDo you want to provide additional information?",
  'INTEGRATIONS.COPILOT.REMOVE_ACCESS_NEXT_STEP':
    'Great! Moving on to next step to remove an access to account',
  'INTEGRATIONS.COPILOT.REMOVE_ACCESS_MAPPING_INFO':
    'Specify the {value0} user fields to populate (as shown in the Add Access UI) and map them to the corresponding Saviynt attributes.\nI noticed that you’ve already added entitlement types—you can either continue with the existing ones or add/edit them as needed.',
  'INTEGRATIONS.COPILOT.STEP_ADD_ACCESS': 'Add Access',
  'INTEGRATIONS.COPILOT.SKIP': 'Skip',
  'INTEGRATIONS.COPILOT.ADD_ACCESS_ENTITLEMENT_TYPE': 'Entitlement type',
  'INTEGRATIONS.COPILOT.ADD_ACCESS_ENTER_ENTITLEMENT_TYPE':
    'Enter entitlement type',
  'INTEGRATIONS.COPILOT.ADD_ACCESS_ADD_NEW_ENTITLEMENT_TYPE':
    'Add Entitlement Type',
  'INTEGRATIONS.COPILOT.MAX_ENTITLEMENTS':
    'Maximum {MAX_ENTITLEMENTS} Entitlement Types can be added!',
  'INTEGRATIONS.COPILOT.CURRENT_ENTITLEMENT':
    'Mapping for {currentEntitlement}',
  'INTEGRATIONS.COPILOT.SAVIYNT': 'Saviynt',
  'INTEGRATIONS.COPILOT.MAX_ENTITLEMENTS_ADDED': 'Maximum Entitlement Added',

  // Form Response Texts
  'INTEGRATIONS.COPILOT.FORM.GENERAL': 'Creating application details',
  'INTEGRATIONS.COPILOT.FORM.CREATE_ACCOUNT_EDIT':
    'Review the Create Account policy. You can update Saviynt/Application attributes and set up instructions to create a user in {applicationName}.',
  'INTEGRATIONS.COPILOT.FORM.UPDATE_ACCOUNT_EDIT':
    'Review the Update Account policy. You can update Saviynt/Application attributes and set up instructions to update a user in {applicationName}.',
  'INTEGRATIONS.COPILOT.FORM.REMOVE_ACCOUNT_EDIT':
    'Review the Remove Account policy. You can update Saviynt/Application attributes and set up instructions to remove a user in {applicationName}.',
  'INTEGRATIONS.COPILOT.FORM.ENABLE_ACCOUNT_EDIT':
    'Review the Enable Account policy. You can update Saviynt/Application attributes and set up instructions to enable a user in {applicationName}.',
  'INTEGRATIONS.COPILOT.FORM.DISABLE_ACCOUNT_EDIT':
    'Review the Disable Account policy. You can update Saviynt/Application attributes and set up instructions to disable a user in {applicationName}.',

  'INTEGRATIONS.COPILOT.FORM.CONNECTION':
    'I’ll assist you with setting up connection details',
  'INTEGRATIONS.COPILOT.FORM.CREATE_ACCOUNT':
    "Ok. I'll assist you with setting up creating an account.\nSpecify the {applicationName} fields to populate (as in the Create User UI) and map them to corresponding Saviynt attributes",
  'INTEGRATIONS.COPILOT.FORM.UPDATE_ACCOUNT':
    "The Saviynt and {applicationName} fields are pre-populated based on your Create Account configuration. \n You can update these fields as they appear in the {applicationName}'s Update User form",
  'INTEGRATIONS.COPILOT.FORM.ENABLE_ACCOUNT':
    'Specify the user field used to find and enable the user in the {applicationName}, then map it to the relevant Saviynt attribute (e.g., Username)',
  'INTEGRATIONS.COPILOT.FORM.DISABLE_ACCOUNT':
    'Specify the user field used to find and disable the user in the {applicationName}, then map it to the relevant Saviynt attribute (e.g., Username)',
  'INTEGRATIONS.COPILOT.FORM.REMOVE_ACCOUNT':
    'Specify the user field used to find and remove the user in the {applicationName}, then map it to the relevant Saviynt attribute (e.g., Username)',
  'INTEGRATIONS.COPILOT.ADD_ACCESS_EDIT_PHASE':
    'Do you want to provide additional information?',
  'INTEGRATIONS.COPILOT.ADD_ACCESS_EDIT_PHASE.ALL_DONE':
    'All the Entitlements are Updated!',
  'INTEGRATIONS.COPILOT.REMOVE_ACCESS_EDIT_INFO':
    'Review the Add Access policy. You can update the entitlement types, Saviynt/Application attributes and set up instructions to remove access to an user in {applicationName}',
  'INTEGRATIONS.COPILOT.ADD_ACCESS_INFO_EDIT_MODE':
    'Review the Add Access policy. You can update the entitlement types, Saviynt/Application attributes and set up instructions to add access to an user in {applicationName}',
  'INTEGRATIONS.COPILOT.REMOVE_ACCESS_SKIPPED':
    "Hey, Seems like you have skipped the Add Access during on-boarding the application so, you can't update the Remove Access configuration.",
};

export default en;
